export default {
  'pages.system.menu.title': 'Menu Management',
  'pages.system.menu.name': 'Menu Name',
  'pages.system.menu.path': 'Path',
  'pages.system.menu.icon': 'Icon',
  'pages.system.menu.order': 'Order',
  'pages.system.menu.enabled': 'Enabled',
  'pages.system.menu.add': 'Add Menu',
  'pages.system.menu.edit': 'Edit Menu',
  'pages.system.menu.delete': 'Delete',
  'pages.system.menu.confirm': 'Confirm Delete',
  'pages.system.menu.confirmContent': 'Are you sure you want to delete this menu?',
  'pages.system.menu.deleteSuccess': 'Delete successful',
  'pages.system.menu.updateSuccess': 'Update successful',
  'pages.system.menu.addSuccess': 'Add successful',
  'pages.system.menu.namePlaceholder': 'Please enter menu name',
  'pages.system.menu.pathPlaceholder': 'Please enter path',
  'pages.system.menu.iconPlaceholder': 'Please enter icon name',
  'pages.system.menu.orderPlaceholder': 'Please enter order number',
  'pages.system.menu.nameRequired': 'Please enter menu name',
  'pages.system.menu.pathRequired': 'Please enter path',
  'pages.system.menu.iconRequired': 'Please enter icon',
  'pages.system.menu.orderRequired': 'Please enter order number',
  'pages.system.menu.enable': 'Enable',
  'pages.system.menu.disable': 'Disable',
  'pages.system.menu.cancel': 'Cancel',
  'pages.system.menu.submit': 'Submit',

  'pages.system.user.title': 'User Management',
  'pages.system.user.username': 'Username',
  'pages.system.user.email': 'Email',
  'pages.system.user.phone': 'Phone',
  'pages.system.user.role': 'Role',
  'pages.system.user.status': 'Status',
  'pages.system.user.add': 'Add User',
  'pages.system.user.edit': 'Edit User',
  'pages.system.user.delete': 'Delete',
  'pages.system.user.confirm': 'Confirm Delete',
  'pages.system.user.confirmContent': 'Are you sure you want to delete this user?',
  'pages.system.user.deleteSuccess': 'Delete successful',
  'pages.system.user.updateSuccess': 'Update successful',
  'pages.system.user.addSuccess': 'Add successful',
  'pages.system.user.usernamePlaceholder': 'Please enter username',
  'pages.system.user.emailPlaceholder': 'Please enter email',
  'pages.system.user.phonePlaceholder': 'Please enter phone',
  'pages.system.user.usernameRequired': 'Please enter username',
  'pages.system.user.emailRequired': 'Please enter email',
  'pages.system.user.emailInvalid': 'Invalid email format',
  'pages.system.user.phoneRequired': 'Please enter phone',
  'pages.system.user.roleRequired': 'Please select role',
  'pages.system.user.statusRequired': 'Please select status',
  'pages.system.user.admin': 'Admin',
  'pages.system.user.normalUser': 'Normal User',
  'pages.system.user.enable': 'Enable',
  'pages.system.user.disable': 'Disable',
  'pages.system.user.cancel': 'Cancel',
  'pages.system.user.submit': 'Submit',

  'pages.system.role.title': 'Role Management',
  'pages.system.role.name': 'Role Name',
  'pages.system.role.description': 'Description',
  'pages.system.role.permissions': 'Permissions',
  'pages.system.role.add': 'Add Role',
  'pages.system.role.edit': 'Edit Role',
  'pages.system.role.delete': 'Delete',
  'pages.system.role.confirm': 'Confirm Delete',
  'pages.system.role.confirmContent': 'Are you sure you want to delete this role?',
  'pages.system.role.deleteSuccess': 'Delete successful',
  'pages.system.role.updateSuccess': 'Update successful',
  'pages.system.role.addSuccess': 'Add successful',
  'pages.system.role.namePlaceholder': 'Please enter role name',
  'pages.system.role.descriptionPlaceholder': 'Please enter description',
  'pages.system.role.nameRequired': 'Please enter role name',
  'pages.system.role.descriptionRequired': 'Please enter description',
  'pages.system.role.permissionsRequired': 'Please select at least one permission',
  'pages.system.role.permissionConfig': 'Permission Configuration',
  'pages.system.role.cancel': 'Cancel',
  'pages.system.role.submit': 'Submit',
};
